import AccommodationView from "../../components/Accommodation/AccommodationView";

function AccommodationMain() {
  return <AccommodationView></AccommodationView>;
}

export default AccommodationMain;
